import { Search } from "@JohnLewisPartnership/jl-design-system/dist/components/search/Search";
import type { InputEvent } from "react";
import styles from "./FacetSearch.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export const FacetSearch = ({
  label = "",
  facetSearchValue = "",
  setFacetSearchValue,
  isFilterDrawer = false,
  isLeftNavHeaderFlagOn = false,
}: {
  label: string;
  facetSearchValue: string;
  setFacetSearchValue: (arg: string) => void;
  isFilterDrawer?: boolean;
  isLeftNavHeaderFlagOn?: boolean;
}) => {
  const handleInput = (event: InputEvent<HTMLInputElement>) => {
    setFacetSearchValue((event.target as HTMLInputElement).value);
  };

  const id = `facet-search-${label}`;
  const drawerLabel = isFilterDrawer ? "filter-drawer-" : "";
  const placeholderText = `Search ${label.toLowerCase()}`;

  return (
    <div
      className={cx("container", {
        filterDrawer: isFilterDrawer,
        "container--lhn-header-on": isLeftNavHeaderFlagOn,
      })}
      data-testid={id}
    >
      <Search
        ariaLabel={placeholderText}
        autoComplete="off"
        id={drawerLabel + id}
        labelText={placeholderText}
        name={id}
        onInput={handleInput}
        placeholder={placeholderText}
        defaultValue={facetSearchValue}
        data-testid={id + "-input"}
      />
    </div>
  );
};
